export default __webpack_public_path__ + "static/media/dialog-blue.0a6cb52a.png";